<template>
  <div>
    <navbar></navbar>
    <section id="centermain">
      <router-view />
    </section>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";

export default {
  components: {
    navbar: Navbar
  },

  methods: {},

  computed: {}
};
</script>
<style>
@import "./vue_app.css";
</style>

